export default {"src":"/_next/static/media/angular.397f2b6c.svg","height":272,"width":256,"blurWidth":0,"blurHeight":0};